import { Outlet, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/footer";
import HeaderCN from "./components/HeaderCN";
import footerCN from "./components/footerCN";

export default function App() {
  const { pathname } = useLocation();

  const isCN = pathname.startsWith("/cn") || (typeof document !== "undefined" && document.documentElement.lang === "zh-CN");

  const hideHeader = pathname === "/login" || pathname === "/cn/login";

  const HeaderComponent = isCN ? HeaderCN : Header;
  const FooterComponent = isCN ? footerCN : Footer;

  return (
    <div id="container">
      {!hideHeader && <HeaderComponent />}
      <div id="contents">
        <Outlet />
      </div>
      {!hideHeader && <FooterComponent />}
    </div>
  );
}
